import { unitById } from "@zend/content";
import type { BattleEvent } from "@zend/rules";
import type { BattleFxKind } from "./BattleFx.js";

/** Content weapon names and ability semantics select the visible weapon, independent of allegiance. */
export function weaponFx(defId: string, label = ""): BattleFxKind {
  if (/corrode|acid/.test(label) || /spitter/.test(defId)) return "acid";
  if (/chain|pierce/.test(label)) return "beam";
  if (/orbital|blast/.test(label)) return "rocket";
  if (defId.startsWith("zmb.")) return "claw";
  if (!defId.startsWith("unit.")) return "ballistic";
  const def = unitById(defId);
  const weapon = def.standard.name.en.toLowerCase();
  if (/blade|sword|slash|dagger/.test(weapon)) return "blade";
  if (/fist|claw/.test(weapon)) return "claw";
  if (/rocket|missile|drone/.test(weapon) || def.chassis === "drone_carrier") return "rocket";
  if (/laser|beam|lance/.test(weapon) || def.chassis === "tripod") return "beam";
  if (def.chassis === "android" || (/pulse|static/.test(weapon) && def.chassis !== "tank")) return "pulse";
  return "ballistic";
}

export function statusFx(event: Pick<BattleEvent, "x" | "v">): BattleFxKind {
  return (event.v ?? 0) < 0 || ["marked", "stun", "corrode", "emp"].includes(event.x ?? "")
    ? "debuff"
    : "buff";
}

export function isUltimate(event: BattleEvent): boolean {
  return event.k === "ability" && !!event.x?.startsWith("ultimate_");
}
